import { render } from "./loginIcon.vue?vue&type=template&id=1014257e"
import script from "./loginIcon.vue?vue&type=script&lang=js"
export * from "./loginIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/advocacy/e-advokat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__